import { render, staticRenderFns } from "./Medicine.vue?vue&type=template&id=2475a314&scoped=true"
import script from "./Medicine.vue?vue&type=script&lang=js"
export * from "./Medicine.vue?vue&type=script&lang=js"
import style0 from "./Medicine.vue?vue&type=style&index=0&id=2475a314&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2475a314",
  null
  
)

export default component.exports